<div class="dialog-container">
    <div class="dialog-title-block">
        <h2>Add Products</h2>
        <div class="flex-container gap-2">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div> 
        </div>
    </div>
    <form #f="ngForm" name="form" (ngSubmit)="f.form.valid && addProduct(f.value)" novalidate>
        <div class="dialog-content-block p-3">
            <div class="form-group position-relative">
                <h6 class="text-start text-dark">Product</h6>
                <input id="product-search--input" #productname="ngModel" type="text" [(ngModel)]="productSearchInput" (focus)="onProductFocus($event)" (keyup)="onProductSearch($event)" name="product_name" required>
                <div id="search-dropdown" class="w-100 search-dropdown position-absolute">
                    <ul *ngIf="searchProductResults.length !==0">
                        <li *ngFor="let product of searchProductResults" (click)="onSelectProduct($event, product?.id, product?.name)">{{ product?.name }}</li>
                    </ul>
                    <ul *ngIf="searchProductResults.length === 0">
                        <li>No products available</li>
                    </ul>
                </div>
                <div class="form-error-msg">
                    <div *ngIf="f.submitted && productname.errors?.required">Product is required</div>
                </div>
            </div>
            <div class="d-flex gap-5 w-100">
                <div class="w-50 d-flex flex-column">
                    <div class="form-group">
                        <h6 class="text-start text-dark">Product Category</h6>
                        <input type="text" [value]="productDetails?.product_category_name" name="product_category" disabled>
                        <div class="form-error-msg"></div>
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">Body Type</h6>
                        <input type="text" [value]="productDetails?.body_part_name" name="body_type" disabled>
                        <div class="form-error-msg"></div>
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">Expiry Date</h6>
                        <input type="date" #expirydate="ngModel" [(ngModel)]="updatedProducts.expiry_date" name="expiry_date" required>
                        <div class="form-error-msg">
                            <div *ngIf="f.submitted && expirydate.errors?.required">Expiry Date is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">RFID</h6>
                        <input #rfid="ngModel" type="text" [(ngModel)]="updatedProducts.rfid" name="rfid" required>
                        <div class="form-error-msg">
                            <div *ngIf="f.submitted && rfid.errors?.required">RFID is required</div>
                            <p *ngIf="serverErrorMessage !== ''">{{ serverErrorMessage }}</p>
                        </div>
                    </div>
                </div>
                <div class="w-50 d-flex flex-column">
                    <div class="form-group">
                        <h6 class="text-start text-dark">Product Code</h6>
                        <input type="text" [value]="productDetails?.code" name="product_code" disabled>
                        <div class="form-error-msg"></div>
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">Implant Type</h6>
                        <input type="text" [value]="productDetails?.implant_name" name="implant_type" disabled>
                        <div class="form-error-msg"></div>
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">Batch Number</h6>
                        <input type="text" #batchno="ngModel" [(ngModel)]="updatedProducts.batch_no" name="batch_no" required>
                        <div class="form-error-msg">
                            <div *ngIf="f.submitted && batchno.errors?.required">Batch number is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <h6 class="text-start text-dark">Rate</h6>
                        <input type="text" [ngClass]="{ 'is-invalid': f.submitted && rate.invalid }" #rate="ngModel" [(ngModel)]="updatedProducts.rate" name="rate" required>
                        <div class="form-error-msg">
                            <div *ngIf="f.submitted && rate.errors?.required">Rate is required</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="form-error-msg">
            <p *ngIf="serverErrorMessage !== ''">{{ serverErrorMessage }}</p>
        </div> -->
        <div class="dialog-footer">
            <button type="button" (click)="onClose()">Cancel</button>
            <button type="submit">Update</button>
        </div>
    </form> 
</div>

